// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome_container__2pu4S","header":"Welcome_header__39hvb","description":"Welcome_description__2CltO"};